export default __webpack_public_path__ + "static/media/andy.4ec67238.png";